import { matchPath, useLocation } from 'react-router-dom'

export default function useShouldHideLayout() {
  const location = useLocation()
  const requisitionOutsideLayout = [
    '/requisitions/create',
    '/requisitions/:requisitionId/submit',
    '/requisitions/:requisitionId/decline',
    '/requisitions/:requisitionId/manage-purchase-orders',
    '/requisitions/:requisitionId/approve',
    '/requisitions/:requisitionId/shop',
    '/requisitions/:requisitionId/add-product',
    '/requisitions/:requisitionId/shop/advanced',
    '/requisitions/:requisitionId/shop/advanced/settings',
    '/requisitions/:requisitionId/shop/advanced/comments',
    '/requisitions/:requisitionId/shop/advanced/attachments',
    '/requisitions/:requisitionId/shop/summary',
    '/requisitions/:requisitionId/shop/settings',
    '/requisitions/:requisitionId/shop/comments',
    '/requisitions/:requisitionId/shop/attachments',
    '/requisitions/:requisitionId/approve',
    '/requisitions/:requisitionId/success',
  ]

  const buyListOutsideLayout = ['/buy-lists/create', '/buy-lists/:buyListId/add-product', '/buy-lists/builder']

  const catalogsOutsideLayout = ['/catalogs/create', '/catalogs/:pricedCatalogueId/add-product']

  const receivingNotesOutsideLayout = [
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/add-product',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/legacy/draft',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/legacy/draft/summary',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/legacy/draft/settings',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/legacy/draft/audit-log',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/received-success',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/draft',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/draft/summary',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/draft/settings',
    '/purchase-orders/:purchaseOrderId/receiving-notes/:receivingNoteId/draft/audit-log',
    '/purchase-orders/:purchaseOrderId/receiving-notes/create',
  ]

  const inventoryOutsideLayout = [
    '/inventory/stock-locations/create',
    '/inventory/system-locations/create',
    '/inventory/stock-items/:stockItemId/add-substitute-product',
    '/inventory/stock-locations/:stockLocationId/stock-items/sort',
    '/inventory/transfers/create',
    '/inventory/stocktakes/start',
    '/inventory/transfers/:transferId/print',
    '/inventory/stocktakes/:stocktakeId/offline',
  ]

  const recipesOutsideLayout = [
    '/recipes/create',
    '/recipes/:recipeId/card',
    '/recipes/:recipeId/add-ingredient',
    '/recipes/:recipeId/print',
  ]

  const menusOutsideLayout = ['/menus/create', '/menus/:id/calculate']
  const usersOutsideLayout = ['/users/create']
  const creditNotesOutsideLayout = [
    '/credit-notes/create',
    '/credit-notes/:creditNoteId/add-line',
    '/credit-notes/credit-note-creator',
    '/credit-notes/:creditNoteId/power-editor',
    '/credit-notes/:creditNoteId/power-editor/summary',
    '/credit-notes/:creditNoteId/power-editor/flags',
    '/credit-notes/:creditNoteId/power-editor/settings',
    '/credit-notes/:creditNoteId/power-editor/comments',
    '/credit-notes/:creditNoteId/power-editor/audit-log',
    '/credit-notes/:creditNoteId/power-editor/attachments',
  ]
  const mySuppliersOutsideLayout = ['/my-suppliers/create']

  const invoicesOutsideLayout = [
    '/invoices/create',
    '/invoices/:invoiceId/add-line',
    '/invoices/:invoiceId/power-editor',
    '/invoices/:invoiceId/power-editor/summary',
    '/invoices/:invoiceId/power-editor/flags',
    '/invoices/:invoiceId/power-editor/analysis',
    '/invoices/:invoiceId/power-editor/settings',
    '/invoices/:invoiceId/power-editor/comments',
    '/invoices/:invoiceId/power-editor/purchase-order',
    '/invoices/:invoiceId/power-editor/receiving-notes',
    '/invoices/:invoiceId/power-editor/credit-notes',
    '/invoices/:invoiceId/power-editor/audit-log',
    '/invoices/:invoiceId/power-editor/attachments',
    '/invoices/export-center/create',
    '/invoices/invoice-creator',
    '/invoices/simple-document-scanner',
    '/invoices/export-center/:exportId/view',
    '/invoices/export-center/:exportId/invoices',
    '/invoices/export-center/:exportId/credit-notes',
  ]

  const pointOfSaleOutsideLayout = [
    '/point-of-sale/items/create',
    '/point-of-sale/batch-sales/create',
    '/point-of-sale/outlets/create',
  ]

  const reportsOutsideLayout = [
    '/reports/:reportShortId/create',
    '/reports/:reportShortId/executions/:reportExecutionId/view',
  ]

  const utilityRoutesOutsideLayout = [
    '/utilities/',
    '/utilities/organisations',
    '/utilities/users',
    '/utilities/catalogs',
    '/utilities/products',
    '/utilities/ap-systems',
    '/utilities/ap-systems/import-accounts',
    '/utilities/ap-systems/import-accounts/create',
    '/utilities/inventory',
    '/utilities/reports',
    '/utilities/public-shop',
    '/utilities/public-shop/orders',
    '/utilities/public-shop/orders/:orderId',
    '/utilities/public-shop/orders/:orderId/summary',
    '/utilities/delete-stock-count-id',
    '/utilities/products/import-products',
    '/utilities/products/import-products/create',
    '/utilities/products/import-barcodes',
    '/utilities/products/import-barcodes/create',
    '/utilities/products/update-products',
    '/utilities/products/update-products/create',
    '/utilities/products/update-product-codes',
    '/utilities/products/update-product-codes/create',
    '/utilities/products/clean-products/create',
    '/utilities/process-products',
    '/utilities/manage-products',
    '/utilities/products/similar-products',
    '/utilities/update-product-code',
    '/utilities/product-codes',
    '/utilities/reports/manage',
    '/utilities/reports/create',
    '/utilities/reports/:reportId',
    '/utilities/reports/:reportId/general',
    '/utilities/reports/:reportId/advanced',
    '/utilities/ap-export-formats',
    '/utilities/ap-export-formats/create',
    '/utilities/ap-export-formats/:apExportFormatId',
    '/utilities/ap-export-formats/:apExportFormatId/general',
    '/utilities/ap-export-formats/:apExportFormatId/variants',
    '/utilities/ap-systems/ap-systems',
    '/utilities/ap-systems/create',
    '/utilities/ap-systems/:apSystemId',
    '/utilities/ap-systems/:apSystemId/general',
    '/utilities/ap-systems/:apSystemId/custom-fields',
    '/utilities/ap-systems/:apSystemId/purchasers',
    '/utilities/ap-systems/:apSystemId/suppliers',
    '/utilities/ap-systems/:apSystemId/accounts',
    '/utilities/ap-systems/:apSystemId/trade-relationships',
    '/utilities/ap-systems/:apSystemId/custom-codes',
    '/utilities/ap-systems/:apSystemId/audit-log',
    '/utilities/ap-systems/:apSystemId/import',
    '/utilities/ap-systems/:apSystemId/export',
    '/utilities/ap-systems/:apSystemId/import/create',
    '/utilities/organisations/billing-groups',
    '/utilities/organisations/billing-groups/:billingGroupId',
    '/utilities/organisations/billing-groups/:billingGroupId/members',
    '/utilities/organisations/billing-groups/:billingGroupId/settings',
    '/utilities/organisations/billing-groups/create',
    '/utilities/organisations/purchasers',
    '/utilities/organisations/suppliers',
    '/utilities/organisations/hierarchies',
    '/utilities/organisations/hierarchies/:organisationId',
    '/utilities/organisations/trade-relationships',
    '/utilities/organisations/destinations',
    '/utilities/organisations/destinations/:tradePipeId',
    '/utilities/organisations/destinations/:tradePipeId/settings',
    '/utilities/organisations/destinations/:tradePipeId/trade-relationships',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/general',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/catalogs',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/supplier-details',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/purchaser-details',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/destinations',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/purchaser-documents',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/supplier-documents',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/advanced',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/audit-log',
    '/utilities/organisations/trade-relationships/:tradeRelationshipId/filter-preferences',
    '/utilities/organisations/import-organisations',
    '/utilities/organisations/import-organisations/create',
    '/utilities/organisations/import-purchasers',
    '/utilities/organisations/import-purchasers/create',
    '/utilities/organisations/import-budgets',
    '/utilities/organisations/import-budgets/create',
    '/utilities/organisations/import-approval-workflows',
    '/utilities/organisations/import-approval-workflows/create',
    '/utilities/organisations/:organisationId',
    '/utilities/organisations/:organisationId/general',
    '/utilities/organisations/:organisationId/customise',
    '/utilities/organisations/:organisationId/ap-system',
    '/utilities/organisations/:organisationId/invoicing',
    '/utilities/organisations/:organisationId/inventory',
    '/utilities/organisations/:organisationId/delivery-addresses',
    '/utilities/organisations/:organisationId/scanning-preferences',
    '/utilities/organisations/:organisationId/trade-relationships',
    '/utilities/organisations/:organisationId/advanced',
    '/utilities/organisations/:organisationId/accounts/update',
    '/utilities/organisations/:organisationId/accounts',
    '/utilities/organisations/:organisationId/public-shop',
    '/utilities/organisations/:organisationId/delivery-fees',
    '/utilities/organisations/:organisationId/audit-log',
    '/utilities/organisations/:organisationId/destinations',
    '/utilities/organisations/purchasers/create',
    '/utilities/organisations/suppliers/create',
    '/organisations/create',
    '/utilities/gql-query-builder',
    '/utilities/users/manage',
    '/utilities/users/imports',
    '/utilities/users/imports/create',
    '/utilities/users/api-keys/manage',
    '/utilities/users/create',
    '/utilities/users/:userId',
    '/utilities/users/:userId/general',
    '/utilities/users/:userId/preferences',
    '/utilities/users/:userId/permissions',
    '/utilities/users/:userId/organisations',
    '/utilities/users/:userId/api-keys',
    '/utilities/users/:userId/audit-log',
    '/utilities/users/:userId/approval-workflows',
    '/utilities/products/:productId',
    '/utilities/products/:productId/details',
    '/utilities/products/:productId/catalogs',
    '/utilities/products/:productId/advanced',
    '/utilities/products/:productId/audit-log',
    '/utilities/products/:productId/matched-products',
    '/utilities/products/:productId/similar-products',
    '/utilities/products/:productId/quotes',
    '/utilities/products/:productId/buylists',
    '/utilities/products/:productId/tags',
    '/utilities/products/:productId/versions',
    '/utilities/scanning-tasks',
    '/utilities/scanning-tasks/emails',
    '/utilities/scanning-tasks/emails/create',
    '/utilities/scanning-tasks/tasks',
    '/utilities/scanning-tasks/tasks/create',
    '/utilities/scanning-tasks/invoice-creator',
    '/utilities/scanning-tasks/credit-note-creator',
    '/utilities/trade-relationship-catalogs',
    '/utilities/catalogs/manage',
    '/utilities/catalogs/:pricedCatalogId/products',
    '/utilities/catalogs/:pricedCatalogId/exports',
    '/utilities/catalogs/:pricedCatalogId/imports',
    '/utilities/catalogs/:pricedCatalogId/audit-log',
    '/utilities/products/grooming-tasks',
    '/utilities/products/grooming-tasks/create',
    '/utilities/products/grooming-tasks/:aiScanningTaskId',
    '/utilities/catalogs/:pricedCatalogId/settings',
    '/utilities/catalogs/:pricedCatalogId/assignments',
    '/utilities/categories',
    '/utilities/invoices/:invoiceId',
    '/utilities/invoices/:invoiceId/summary',
    '/utilities/invoices/:invoiceId/flags',
    '/utilities/invoices/:invoiceId/analysis',
    '/utilities/invoices/:invoiceId/settings',
    '/utilities/invoices/:invoiceId/comments',
    '/utilities/invoices/:invoiceId/purchase-order',
    '/utilities/invoices/:invoiceId/receiving-notes',
    '/utilities/invoices/:invoiceId/audit-log',
    '/utilities/invoices/:invoiceId/attachments',
    '/utilities/invoices/:invoiceId/credit-notes',
    '/utilities/invoices/:invoiceId/power-editor',
    '/utilities/invoices/:invoiceId/power-editor/summary',
    '/utilities/invoices/:invoiceId/power-editor/flags',
    '/utilities/invoices/:invoiceId/power-editor/analysis',
    '/utilities/invoices/:invoiceId/power-editor/settings',
    '/utilities/invoices/:invoiceId/power-editor/comments',
    '/utilities/invoices/:invoiceId/power-editor/credit-notes',
    '/utilities/invoices/:invoiceId/power-editor/purchase-order',
    '/utilities/invoices/:invoiceId/power-editor/receiving-notes',
    '/utilities/invoices/:invoiceId/power-editor/attachments',
    '/utilities/invoices/:invoiceId/power-editor/audit-log',
    '/utilities/credit-notes',
    '/utilities/credit-notes/:creditNoteId',
    '/utilities/credit-notes/:creditNoteId/summary',
    '/utilities/credit-notes/:creditNoteId/flags',
    '/utilities/credit-notes/:creditNoteId/settings',
    '/utilities/credit-notes/:creditNoteId/comments',
    '/utilities/credit-notes/:creditNoteId/attachments',
    '/utilities/credit-notes/:creditNoteId/audit-log',
    '/utilities/credit-notes/:creditNoteId/power-editor',
    '/utilities/credit-notes/:creditNoteId/power-editor/summary',
    '/utilities/credit-notes/:creditNoteId/power-editor/flags',
    '/utilities/credit-notes/:creditNoteId/power-editor/settings',
    '/utilities/credit-notes/:creditNoteId/power-editor/comments',
    '/utilities/credit-notes/:creditNoteId/power-editor/attachments',
    '/utilities/credit-notes/:creditNoteId/power-editor/audit-log',
    '/utilities/scanning-tasks/process-documents',
    '/utilities/scanning-tasks/process-documents/:id/process-document',
    '/utilities/scanning-tasks/process-documents/:id/paperless-email',
    '/utilities/scanning-tasks/process-documents/:id/scanning-task',
    '/utilities/scanning-tasks/process-documents/:id/invoice',
    '/utilities/scanning-tasks/process-documents/:id/credit-note',
    '/utilities/scanning-tasks/process-documents/:id/audit-log',
    '/utilities/invoices',
    '/utilities/invoices/all-invoices',
    '/utilities/purchase-orders',
    '/utilities/purchase-orders/all-purchase-orders',
    '/utilities/purchase-orders/:purchaseOrderId',
    '/utilities/purchase-orders/:purchaseOrderId/summary',
    '/utilities/purchase-orders/:purchaseOrderId/settings',
    '/utilities/purchase-orders/:purchaseOrderId/comments',
    '/utilities/purchase-orders/:purchaseOrderId/invoices',
    '/utilities/purchase-orders/:purchaseOrderId/receiving-notes',
    '/utilities/purchase-orders/:purchaseOrderId/audit-log',
    '/utilities/purchase-orders/:purchaseOrderId/send-events',
    '/utilities/recipes',
    '/utilities/recipes/all-recipes',
    '/utilities/quotes',
    '/utilities/quotes/all-quotes',
    '/utilities/buy-lists',
    '/utilities/buy-lists/manage',
    '/utilities/products/product-tags',
    '/utilities/products/product-tags/:tagId/settings',
    '/utilities/products/product-tags/:tagId/products',
    '/utilities/products/allergens',
    '/utilities/products/allergens/:allergenId/settings',
    '/utilities/buy-lists/:buyListId/products',
    '/utilities/buy-lists/:buyListId/settings',
    '/utilities/buy-lists/:buyListId/imports',
    '/utilities/buy-lists/:buyListId/exports',
    '/utilities/scanning-tasks/paperless-emails',
    '/utilities/barcodes',
    '/utilities/scanning-tasks/paperless-emails/:paperlessEmailId/paperless-email',
    '/utilities/scanning-tasks/paperless-emails/:paperlessEmailId/process-documents',
    '/utilities/scanning-tasks/paperless-emails/:paperlessEmailId/scanning-tasks',
    '/utilities/scanning-tasks/paperless-emails/:paperlessEmailId/invoices',
    '/utilities/scanning-tasks/paperless-emails/:paperlessEmailId/credit-notes',
    '/utilities/scanning-tasks/paperless-emails/:paperlessEmailId/action-items',
    '/utilities/scanning-tasks/paperless-emails/action-items/:actionItemId/action-item',
    '/utilities/scanning-tasks/paperless-emails/action-items/:actionItemId/paperless-email',
    '/utilities/scanning-tasks/paperless-emails/action-items',
    '/utilities/ap-systems/account-codes/:accountCodeId',
    '/utilities/ap-systems/account-codes/:accountCodeId/general',
    '/utilities/ap-systems/account-codes/:accountCodeId/children',
    '/utilities/ap-systems/account-codes/:accountCodeId/organisations',
    '/utilities/ap-systems/organisation-accounts/:organisationAccountId',
    '/utilities/ap-systems/organisation-accounts/:organisationAccountId/budgets',
    '/utilities/ap-systems/organisation-accounts/:organisationAccountId/general',
    '/utilities/ap-systems/budgets/:budgetId',
    '/utilities/ap-systems/budgets/:budgetId/usage',
    '/utilities/ap-systems/budgets/:budgetId/requisitions',
    '/utilities/ap-systems/budgets/:budgetId/settings',
    '/utilities/organisation-tags',
    '/utilities/organisation-tags/:organisationTagId',
    '/utilities/organisation-tags/:organisationTagId/organisations',
    '/utilities/organisation-tags/:organisationTagId/settings',
  ]

  const apSystemOutsideLayout = [
    '/ap-system/',
    '/ap-system/general',
    '/ap-system/custom-fields',
    '/ap-system/purchasers',
    '/ap-system/suppliers',
    '/ap-system/accounts',
    '/ap-system/trade-relationships',
  ]

  const systemSettingsOutsideLayout = [
    '/settings/approval-workflows/create',
    '/settings/organisations/:organisationId/accounts/update',
    '/settings/ap-system/import/create',
  ]

  const publicShopOutsideLayout = [
    '/shop',
    '/shop/:organisationId',
    '/shop/:organisationId/summary',
    '/shop/:organisationId/order/:orderUuid/payment',
    '/shop/:organisationId/checkout',
  ]

  const purchaseProductsOutsideLayout = [
    '/products/:productId/add-substitute-product',
    '/products/import-products/create',
  ]

  const scanningTasksOutsideLayout = ['/scanning-tasks/create']

  const budgetsOutsideLayout = ['/budgets/create', '/budgets/import-budgets/create']

  const legacyStocktakesOutsideLayout = ['/stocktakes/stock-location/:stockLocationId/stocktake/:stocktakeId/offline']

  const paperlessEmailActionItemsOutsideLayout = [
    '/paperless-emails/action-items/:id/action-item',
    '/paperless-emails/action-items/:id/paperless-email',
  ]

  const statementImportOutsideLayout = [
    '/statements/upload',
    '/statements/:statementId/power-editor',
    '/statements/:statementId/power-editor/summary',
    '/statements/:statementId/power-editor/invoices',
    '/statements/:statementId/power-editor/credit-notes',
    '/statements/:statementId/power-editor/unmatched',
  ]
  const purchaseOrderPrintJobOutsideLayout = ['purchase-orders/print/:purchaseOrderPrintJobId']

  const noLayoutPaths = [
    ...requisitionOutsideLayout,
    ...buyListOutsideLayout,
    ...catalogsOutsideLayout,
    ...receivingNotesOutsideLayout,
    ...inventoryOutsideLayout,
    ...recipesOutsideLayout,
    ...menusOutsideLayout,
    ...usersOutsideLayout,
    ...invoicesOutsideLayout,
    ...creditNotesOutsideLayout,
    ...reportsOutsideLayout,
    ...utilityRoutesOutsideLayout,
    ...apSystemOutsideLayout,
    ...publicShopOutsideLayout,
    ...purchaseProductsOutsideLayout,
    ...mySuppliersOutsideLayout,
    ...systemSettingsOutsideLayout,
    ...pointOfSaleOutsideLayout,
    ...scanningTasksOutsideLayout,
    ...budgetsOutsideLayout,
    ...paperlessEmailActionItemsOutsideLayout,
    ...legacyStocktakesOutsideLayout,
    ...statementImportOutsideLayout,
    ...purchaseOrderPrintJobOutsideLayout,
  ]

  const shouldHideLayout = noLayoutPaths.some((path) => matchPath(path, location.pathname))

  return {
    noLayoutPaths,
    shouldHideLayout,
  }
}
